<button
  #teamButton
  type="button"
  role="menuitem"
  class="mc-team-button"
  [ngClass]="{
    active: isActive,
  }"
  (click)="onSwitchToTeam(team())"
>
  <div class="mc-team-button-img-wrapper">
    @if (team().myMembershipTeamOwnerPictureUrl) {
      <img
        [src]="team().myMembershipTeamOwnerPictureUrl"
        mcImgCacheBuster
        alt="{{ team().myMembershipTeamName }} logo"
      />
    } @else {
      <div class="mc-team-button-img-wrapper__short-team-name">
        {{ getShortName(team().myMembershipTeamName) }}
      </div>
    }
  </div>
  <div class="mc-team-button__text">
    <p class="mc-team-button__team-name">{{ team().myMembershipTeamName }}</p>
    @if (team().memberAccessType === 'ORIGINAl_OWNER') {
      <p class="mc-team-button__owner">My account</p>
    }
  </div>
</button>
